module.exports = __webpack_public_path__ + "img/alex.8db6b16e.svg";